import {useEffect, useCallback} from 'react';

export const useXVisible = ({horizontalScroll, ref, isSelected}) => {
    useEffect(() => {
        if (!isSelected ||
            !horizontalScroll ||
            !ref ||
            !horizontalScroll.current ||
            !ref.current) {
            return;
        }

        // check if visible
        let scrollLeft = horizontalScroll.current.scrollLeft;
        let scrollWidth = horizontalScroll.current.offsetWidth;
        let scrollRight = scrollLeft + scrollWidth;

        let left = ref.current.offsetLeft;
        let right = left + ref.current.offsetWidth;
        let mid = (left + right) / 2;
        if (mid < scrollLeft || mid > scrollRight) {
            // then we need to scroll
            horizontalScroll.current.scrollTo(left - 150, 0);
        }
    }, [isSelected, ref, horizontalScroll]);
};
